"use client";

import {
  blockDownlineMitra,
  editDiscountBrand,
  getDetailDownlineMitra,
  getDiscountBrand,
  getDownlineMitra,
  updatePasswordMitra,
} from "@/functions/databaseData";
import useModal from "@/functions/useModal";
import useAlert from "@/functions/useAlert";
import {
  EyeOffSvg,
  EyeOnSvg,
  PenEditSolidSvg,
  PlusOutlineSvg,
  RemoveSvg,
  SaleSvg,
  SaveSolidSvg,
  SearchSvg,
  ToggleOffSvg,
  ToggleOnSvg,
} from "@/public/svg";
import { format, parseISO } from "date-fns";
import { useRouter } from "next/navigation";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { twMerge } from "tailwind-merge";
import { FooterTable } from "../../_component";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import Input from "@/components/atom/Input";
import Button from "@/components/atom/Button";
import ContainerModal from "@/components/sub-atom/ContainerModal";
import InputTitle from "@/components/sub-atom/InputTitle";
import Label from "@/components/sub-atom/Label";
import Divider from "@/components/atom/Divider";
import checkLevel from "@/functions/checkLevel";
import useHeader from "@/functions/useHeader";
import { ScrollPagination } from "@/components/atom/Pagination";
import aesEncript from "crypto-js/aes";
import encEncript from "crypto-js/enc-utf8";
import generateRandomString from "@/functions/generateRandomString";

function decryptPassword(ciphertext, secretKey) {
  // Decrypt the password
  const bytes = aesEncript.decrypt(ciphertext, secretKey);
  const originalPassword = bytes.toString(encEncript);
  return originalPassword;
}

export default function Jaringan() {
  const { session } = useHeader();
  const { showAlert } = useAlert();
  const router = useRouter();
  const { openModal, closeModal } = useModal();
  const [dataModal, setDataModal] = useState({
    user: {},
    dataDiscount: [],
  });
  const [downlineMitra, setDownlineMitra] = useState([]);
  const [search, setSearch] = useState("");
  const [typeModal, setTypeModal] = useState("change");
  const [forms, setForms] = useState({});
  const [errors, setErrors] = useState({});
  const [showListTypeDiskon, setShowListTypeDiskon] = useState({
    myAll: {
      value: "persentase",
    },
  });
  const [disabled, setDisabled] = useState({
    key: false,
  });
  const [trigger, setTrigger] = useState(false);
  const [loading, setLoading] = useState({});
  const [show, setshow] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [resetPassword, setResetPassword] = useState({
    active: false,
    new_password: "",
    hidePw: false,
  });

  const headList = [
    "Aksi",
    "Suspend",
    "Nama",
    "Telp",
    "Email",
    "Level",
    "Tanggal",
  ];

  async function handleChangeDiscount(item, multi = false) {
    // check apakah change nya multi
    // --> multi -----------> false
    // cek showListTypeDiskon?.[item?.name_brand].value
    // --> nominal
    // diskon_brand = 0
    // diskon_brand_nominal = forms?.discount_sale?.[item?.name_brand]
    // --> persentase
    // diskon_brand = forms?.discount_range?.[item?.name_brand]
    // diskon_brand_nominal = 0

    // --> multi -----------> true
    // cek showListTypeDiskon?.[item?.name_brand].value
    // --> nominal
    // diskon_brand = 0
    // diskon_brand_nominal = forms?.discount_sale_all
    // list_mitra = list_mitra
    // --> persentase
    // diskon_brand = forms?.discount_range_all
    // diskon_brand_nominal = 0
    // list_mitra = list_mitra

    let isBody = {};
    let isBodyRange = multi
      ? {
          diskon_brand_nominal: 0,
          diskon_brand: Number(forms?.discount_range_all),
          list_mitra: item,
        }
      : {
          diskon_brand_nominal: 0,
          diskon_brand: forms?.discount_range?.[item?.name_brand],
        };

    let isBodySale = multi
      ? {
          diskon_brand_nominal: Number(forms?.discount_sale_all),
          diskon_brand: 0,
          list_mitra: item,
        }
      : {
          diskon_brand_nominal: forms?.discount_sale?.[item?.name_brand],
          diskon_brand: 0,
        };

    isBody = (
      multi
        ? showListTypeDiskon?.[item?.name_brand]?.value == "nominal"
        : showListTypeDiskon?.myAll?.value == "nominal"
    )
      ? isBodySale
      : isBodyRange;

    const payload = multi
      ? {
          body: isBody,
          token: session?.user?.token,
          multi,
        }
      : {
          body: isBody,
          id_discount: item?.id_diskon,
          id_mitra: item?.mitra_id,
          token: session?.user?.token,
        };

    try {
      const res = await editDiscountBrand(payload);

      if (!res.error) {
        setErrors({});
        setTypeModal("");
        setTrigger(true);
        multi && closeModal();
        setDisabled((old) => ({ ...old, [item?.name_brand]: false }));
        return toast.success(
          res?.message ?? "Success melakukan update diskon jaringan",
          {
            position: "top-center",
          }
        );
      }
      throw new Error(res?.error?.message ?? res?.error);
    } catch (error) {
      toast.error(`Failed change discount : ${error?.message ?? res}`, {
        position: "top-center",
      });
    } finally {
      setErrors({});
      setShowListTypeDiskon((old) => ({
        ...old,
        myAll: { ...old?.myAll, show: false },
      }));
    }
  }

  function handleBlockDownlineMitra(item, status = true) {
    async function runBlockMitra(item, status, msg = "") {
      try {
        if (status && (!msg || msg?.length <= 0))
          throw new Error("Masukkan alasan anda terlebih dahulu");

        const res = await blockDownlineMitra({
          body: {
            is_semi_block: status,
            message: msg,
          },
          token: session?.user?.token,
          id: item?.mitra_id,
        });
        if (!res.error) {
          toast.success(res?.message ?? "Success update status user", {
            position: "top-center",
          });
          return runGetDownlineMitra();
        }
        throw new Error(res?.error?.message ?? res?.error);
      } catch (error) {
        toast.error(`Error : ${error?.message}`, {
          position: "top-center",
        });
      }
    }

    let msg = "";
    const message = () =>
      status ? (
        <div className='flex flex-col gap-4'>
          <p>
            Apakah Anda yakin akan menangguhkan akun?{" "}
            <strong className='capitalize'>{item?.username}</strong> tidak akan
            bisa melakukan transaksi di {process.env.COMPANY_NAME}.
          </p>
          <Input
            placeholder='Masukkan alasan! menangguhkan akun'
            onChange={(a) => {
              msg = a;
            }}
          />
        </div>
      ) : (
        <p>
          Apakah Anda yakin akan mengaktifkan akun?{" "}
          <strong className='capitalize'>{item?.username}</strong> akan bisa
          melakukan transaksi di {process.env.COMPANY_NAME}
        </p>
      );
    const btnOpen = status
      ? { onClick: () => {}, text: "Tidak, Batalkan" }
      : { onClick: () => runBlockMitra(item, status), text: "Ya, Aktifkan" };
    const btnClose = status
      ? {
          onClick: () => runBlockMitra(item, status, msg),
          text: "Ya, Nonaktifkan",
        }
      : { onClick: () => {}, text: "Tidak, Batalkan" };

    showAlert({
      colors: "success",
      versiAlert: 2,
      title: "Konfirmasi",
      desc: () => message(),
      handleClick: {
        open: {
          ...btnOpen,
          hide: false,
        },
        close: {
          ...btnClose,
          hide: false,
        },
      },
    });
  }

  useEffect(() => {
    if (trigger) {
      runGetDownlineMitra();
      runGetDiscountBrand();
      setTrigger(false);
    }
  }, [trigger]);

  useEffect(() => {
    if (downlineMitra?.length <= 0) runGetDownlineMitra();
    if (dataModal?.user?.mitra_id) runGetDiscountBrand();
  }, [dataModal?.user]);

  const runGetDownlineMitra = useCallback(async () => {
    try {
      const res = await getDownlineMitra({
        id: session?.user?.data?.mitra_id,
        token: session?.user?.token,
      });
      setDownlineMitra(res?.reverse());
    } catch (error) {
      console.log(error.message);
    }
  }, [trigger]);

  const runGetDiscountBrand = useCallback(async () => {
    try {
      const res = await getDiscountBrand({
        id: dataModal?.user?.mitra_id,
        token: session?.user?.token,
      });
      setDataModal((old) => ({ ...old, dataDiscount: res }));

      let discount_range = {};
      let discount_sale = {};
      let listTypeDiskon = {};

      res.forEach((val) => {
        Object.assign(discount_range, {
          [val?.name_brand]: val?.diskon_brand,
        });
        Object.assign(discount_sale, {
          [val?.name_brand]: val?.diskon_brand_nominal,
        });
        Object.assign(listTypeDiskon, {
          myAll: {
            show: false,
            value: "persentase",
          },
          [val?.name_brand]: {
            value: "persentase",
            show: false,
          },
        });
      });

      setForms({
        discount_range,
        discount_sale,
      });
      setShowListTypeDiskon(listTypeDiskon);
    } catch (error) {
      console.log(error.message);
    }
  }, [dataModal?.user]);

  const handleOpenDetailJaringan = async (item) => {
    try {
      const res =
        (await getDetailDownlineMitra({
          id: item?.mitra_id,
          token: session?.user?.token,
        })) || {};

      openModal();
      setTypeModal("detail-jaringan");
      setDataModal((old) => ({ ...old, user: { ...item, ...res } }));
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleResetPassword = async () => {
    setLoading((old) => ({ ...old, resetPassword: true }));
    try {
      if (
        !resetPassword?.new_password ||
        resetPassword?.new_password.length < 8
      )
        throw new Error("Kata sandi minimal 8 karakter");

      let res = await updatePasswordMitra({
        body: {
          default: false,
          mitra_id: dataModal?.user?.mitra_id,
          password: resetPassword?.new_password,
        },
        token: session?.user?.token,
      });
      await handleOpenDetailJaringan(dataModal.user);
      setResetPassword({});
      toast.success(res?.message, {
        position: "top-center",
      });
    } catch (error) {
      console.log(error.message);
      toast.error(`Error : ${error.message}`, {
        position: "top-center",
      });
    } finally {
      setLoading((old) => ({ ...old, resetPassword: false }));
    }
  };

  const listStatusJaringan = useMemo(
    () => [
      {
        id: 1,
        title: "Semua Jaringan",
        value: downlineMitra,
        status: show == 1 ? "active" : "noActive",
        key: "all",
      },
      {
        id: 2,
        title: "Jaringan Aktif",
        value: downlineMitra?.filter((val) => !val?.is_semi_block),
        status: show == 2 ? "active" : "noActive",
      },
      {
        id: 3,
        title: "Jaringan Non-Aktif",
        value: downlineMitra?.filter((val) => val?.is_semi_block),
        status: show == 3 ? "active" : "noActive",
      },
    ],
    [downlineMitra, show]
  );

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;

    const isDownlineMitra = listStatusJaringan
      ?.filter((val) => val?.status == "active")?.[0]
      ?.value?.filter((item) => {
        return search?.length > 0
          ? item?.username?.toLowerCase()?.includes(search?.toLowerCase()) ||
              item?.email?.toLowerCase()?.includes(search?.toLowerCase()) ||
              item?.telephone?.toLowerCase()?.includes(search?.toLowerCase())
          : item;
      });
    return isDownlineMitra?.slice(firstPageIndex, lastPageIndex);
  }, [pageSize, currentPage, downlineMitra, listStatusJaringan, search]);

  return (
    <React.Fragment>
      <div className='flex flex-col gap-4 xs:gap-8'>
        <div className=' bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8'>
          <div className='flex flex-col-reverse xs:flex-row justify-between gap-2 items-center'>
            <div className='flex items-center gap-4 w-full'>
              <Input
                icon={{
                  left: (props) => <SearchSvg {...props} />,
                }}
                placeholder='Cari berdasarkan nama, email atau nomor Hp...'
                onChange={(val) => setSearch(val)}
                value={search}
                onSubmit={(e) => e.preventDefault()}
                // onKeyDown={() => router.push(`/search/${valueSearch}`)}
                enterKeyHint={"search"}
              />
            </div>
            <div className='flex w-full justify-end gap-2 flex-col xs:flex-row'>
              <Button
                className='flex w-full xs:w-auto'
                colors='warning'
                label='Atur Diskon All'
                variants='solid'
                onClick={() => {
                  openModal();
                  setTypeModal("changeAll");
                }}
                icon={{
                  left: (props) => <SaleSvg {...props} />,
                }}
              />
              <Button
                className='flex w-full xs:w-auto'
                label='Tambah Jaringan'
                variants='solid'
                onClick={() => router?.push("jaringan-saya/tambah-jaringan")}
                icon={{
                  left: (props) => <PlusOutlineSvg {...props} />,
                }}
              />
            </div>
          </div>
        </div>
        <div className=' bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8 overflow-hidden overflow-x-scroll'>
          <div className='flex flex-col-reverse xs:flex-row gap-2 mb-4'>
            <ScrollPagination
              datas={listStatusJaringan}
              className='flex flex-row gap-2 w-full'
              renderItem={({ item, index }) => {
                const colors = {
                  active: "primaryGON",
                  noActive: "greyscaleGON",
                };
                return (
                  <div
                    key={index}
                    onClick={() => {
                      setshow(item?.id);
                    }}
                    className='flex flex-col items-center gap-3 cursor-pointer'>
                    <div className='gap-2 px-4 flex items-center'>
                      <p
                        className={`p1-medium whitespace-nowrap  capitalize text-${
                          colors?.[item?.status]
                        }-${item?.status == "active" ? "400" : "700"} `}>
                        {item?.subTitle ?? item?.title}
                      </p>
                      <p
                        className={`text-button-medium ml-2 rounded-lg border border-${
                          colors?.[item?.status]
                        }-50 bg-${colors?.[item?.status]}-50 px-2 py-1 text-${
                          colors?.[item?.status]
                        }-400 group-focus-visible:border-${
                          colors?.[item?.status]
                        }-200`}>
                        {item?.value?.length > 99 ? "99+" : item?.value?.length}
                      </p>
                    </div>
                    {item?.status == "active" && (
                      <div
                        className={`flex h-1 w-full rounded-tl-xl rounded-tr-xl bg-${
                          colors?.[item?.status]
                        }-400`}
                      />
                    )}
                  </div>
                );
              }}
            />
          </div>
          <table className='table-auto w-full'>
            <thead>
              <tr>
                {headList?.map((item, index) => (
                  <th
                    key={index}
                    // className={twMerge("p-4", index === 0 ? "w-32" : " w-32")}
                    className={twMerge(
                      "pb-4 border-b-[1px] border-greyscaleGON-200"
                    )}>
                    <p className='capitalize text-start p2-medium text-greyscaleGON-700 max-w-full whitespace-nowrap overflow-hidden text-ellipsis'>
                      {item}
                    </p>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className='bg-shadesGON-50'>
              {currentTableData?.map((item, index) => (
                <tr key={(currentPage - 1) * pageSize + (index + 1)}>
                  <td className={twMerge("pr-3 py-3")}>
                    <div className='flex flex-row items-center gap-2'>
                      <div
                        onClick={() => handleOpenDetailJaringan(item)}
                        className='cursor-pointer'>
                        <EyeOnSvg className='text-primaryGON-400 w-8 h-8' />
                      </div>
                      <div
                        onClick={() => {
                          openModal();
                          setTypeModal("setting-diskon");
                          setDataModal((old) => ({ ...old, user: item }));
                        }}
                        className='cursor-pointer'>
                        <SaleSvg className='text-warningGON-400 w-8 h-8' />
                      </div>
                    </div>
                  </td>
                  <td className={twMerge("pr-3 py-3")}>
                    {item?.is_semi_block ? (
                      <div
                        className='flex gap-2 items-center cursor-pointer'
                        onClick={() => handleBlockDownlineMitra(item, false)}>
                        <ToggleOnSvg className='h-8 w-8 md:h-10 md:w-10 text-primaryGON-400' />
                      </div>
                    ) : (
                      <div
                        className='flex gap-2 items-center cursor-pointer'
                        onClick={() => handleBlockDownlineMitra(item, true)}>
                        <ToggleOffSvg className='h-8 w-8 md:h-10 md:w-10 text-greyscaleGON-400' />
                      </div>
                    )}
                  </td>
                  <td className={twMerge("p-3")}>
                    <p className='text-wrap w-auto line-clamp-2 hover:line-clamp-none capitalize p1-regular text-greyscaleGON-700'>
                      {item?.username}
                    </p>
                  </td>
                  <td className={twMerge("p-3")}>
                    <p className='text-wrap w-auto line-clamp-1 hover:line-clamp-none capitalize p2-regular text-greyscaleGON-700'>
                      {item?.telephone ?? "-"}
                    </p>
                  </td>
                  <td className={twMerge("p-3")}>
                    <p className='text-wrap w-auto line-clamp-2 p2-regular text-greyscaleGON-700'>
                      {item?.email}
                    </p>
                  </td>

                  <td className={twMerge("p-3")}>
                    <p className='text-wrap w-auto line-clamp-2 p1-regular text-greyscaleGON-700'>
                      {checkLevel(item?.mitra_level)}
                    </p>
                  </td>

                  <td className={twMerge("p-3")}>
                    <p className='text-wrap w-auto line-clamp-2 p1-regular text-greyscaleGON-700'>
                      {format(parseISO(item?.created_at), "yyyy-MM-dd")}
                    </p>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <FooterTable
            currentPage={currentPage}
            totalCount={downlineMitra?.length}
            pageSize={pageSize}
            setPageSize={setPageSize}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      </div>
      {typeModal == "changeAll" ? (
        <ContainerModal
          className={twMerge(
            `flex max-w-[552px] min-h-[400px] flex-col justify-center gap-4`
          )}>
          <div className='flex flex-col p-4 xs:p-8 gap-8'>
            <p className='subheading-medium text-greyscaleGON-400'>
              Pengaturan Diskon{" "}
              <span className='text-primaryGON-400 capitalize'>All</span>
            </p>
            <div>
              {errors?.diskon_brand?.length > 0 && (
                <Label
                  colors='error'
                  title={errors?.diskon_brand}
                />
              )}
              <Divider />
            </div>
            <div className='flex items-center w-full gap-4 flex-col'>
              <div className='w-full flex xs:flex-row flex-col justify-between gap-4'>
                <div className='flex flex-col xs:w-[50%] w-full gap-1'>
                  <p className='p1-medium text-greyscaleGON-700 capitalize'>
                    Filter Special
                  </p>
                  <p className='p3-medium text-greyscaleGON-400'>
                    Jika aktif, pilihan akan lebih spesifik daripada sebelumnya.
                  </p>
                </div>
                {forms?.activeFilterSpecial ? (
                  <div
                    onClick={() =>
                      setForms((old) => ({
                        ...old,
                        activeFilterSpecial: false,
                        listMitra: [],
                      }))
                    }>
                    <ToggleOnSvg className='h-8 w-8 xs:h-8 xs:w-8 text-primaryGON-400' />
                  </div>
                ) : (
                  <div
                    onClick={() => {
                      setForms((old) => ({
                        ...old,
                        activeFilterSpecial: true,
                        listMitra: [],
                      }));
                    }}>
                    <ToggleOffSvg className='h-8 w-8 xs:h-8 xs:w-8 text-greyscaleGON-500' />
                  </div>
                )}
              </div>
              <div className='flex flex-col w-full gap-4'>
                <ReactSelect
                  placeholder='Pilih'
                  menuPlacement='top'
                  maxMenuHeight={120}
                  className='w-full'
                  value={forms?.listMitra}
                  options={
                    forms?.activeFilterSpecial
                      ? [
                          {
                            label: "Semua Mitra",
                            value: "all",
                          },
                          {
                            label: "Khusus Reseller",
                            value: 4,
                          },
                        ]
                      : downlineMitra?.map((item) => ({
                          value: item?.mitra_id,
                          label: item?.username,
                        }))
                  }
                  isMulti={forms?.activeFilterSpecial ? false : true}
                  closeMenuOnSelect={forms?.activeFilterSpecial}
                  onChange={(val) =>
                    setForms((old) => ({ ...old, listMitra: val }))
                  }
                />
              </div>
              <div className=' flex flex-col gap-4 w-full'>
                <InputTitle title={"Nilai Diskon"} />
                <div className='relative flex w-full items-center gap-4'>
                  <div className='flex w-full'>
                    <Input
                      placeholder={
                        showListTypeDiskon?.myAll?.value == "nominal"
                          ? "Rp. 0"
                          : "0%"
                      }
                      type='number'
                      value={
                        forms?.[
                          showListTypeDiskon?.myAll?.value == "nominal"
                            ? "discount_sale_all"
                            : "discount_range_all"
                        ]
                      }
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleChangeDiscount(
                          forms?.activeFilterSpecial
                            ? downlineMitra
                                ?.filter((val) =>
                                  forms?.listMitra?.value == "all"
                                    ? val
                                    : val?.mitra_level ==
                                      forms?.listMitra?.value
                                )
                                ?.map((item) => item?.mitra_id)
                            : forms?.listMitra?.map((item) => item?.value),
                          true
                        );
                      }}
                      onChange={(val) =>
                        setForms((old) => ({
                          ...old,
                          [showListTypeDiskon?.myAll?.value == "nominal"
                            ? "discount_sale_all"
                            : "discount_range_all"]: val,
                        }))
                      }
                    />
                  </div>
                  {/* <div
                    onClick={() => {
                      setForms((old) => ({
                        ...old,
                        [showListTypeDiskon?.myAll?.value == "nominal"
                          ? "discount_sale_all"
                          : "discount_range_all"]: "",
                      }));
                      setShowListTypeDiskon((old) => ({
                        ...old,
                        myAll: {
                          ...old?.myAll,
                          show: !showListTypeDiskon?.myAll?.show,
                        },
                      }));
                    }}
                    className='flex flex-row items-center gap-1'>
                    <p className='p1-regular min-w-[20px]'>
                      {showListTypeDiskon?.myAll?.value == "nominal"
                        ? "Rp."
                        : "%"}{" "}
                    </p>
                    <ChevronDownSvg className='text-greyscaleGON-700 w-4 h-4' />
                  </div> */}
                  {/* {showListTypeDiskon?.myAll?.show && (
                    <div
                      className='absolute right-0 z-10 mt-2 w-fit origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none'
                      role='menu'
                      aria-orientation='vertical'
                      aria-labelledby='menu-button'
                      tabIndex='-1'>
                      <div
                        className='py-1'
                        role='none'>
                        {[
                          { label: "Rp", value: "nominal" },
                          { label: "%", value: "persentase" },
                        ]?.map((val, key) => (
                          <span
                            key={key}
                            onClick={() => {
                              setShowListTypeDiskon((old) => ({
                                ...old,
                                myAll: {
                                  show: !showListTypeDiskon?.myAll?.show,
                                  value: val?.value,
                                },
                              }));
                            }}
                            className={twMerge(
                              showListTypeDiskon?.myAll?.value == val?.value
                                ? "text-primaryGON-400"
                                : "text-greyscaleGON-700",
                              "capitalize block px-4 py-2 text-sm cursor-pointer"
                            )}
                            role='menuitem'
                            tabIndex='-1'
                            id='menu-item-0'>
                            {val?.label}
                          </span>
                        ))}
                      </div>
                    </div>
                  )} */}
                </div>
              </div>
            </div>
            <div className='flex flex-col xs:flex-row w-full justify-between gap-4 items-center '>
              <Button
                label='Tutup'
                variants='outline'
                onClick={() => {
                  closeModal();
                  setDisabled({});
                  setForms({});
                  setShowListTypeDiskon((old) => ({
                    ...old,
                    myAll: { ...old?.myAll, show: false },
                  }));
                }}
                className='w-full'
              />
              <Button
                label='Simpan'
                disable={
                  !forms?.[
                    showListTypeDiskon?.myAll?.value == "nominal"
                      ? "discount_sale_all"
                      : "discount_range_all"
                  ] ||
                  !forms?.listMitra ||
                  forms?.listMitra?.length <= 0
                }
                onClick={() =>
                  handleChangeDiscount(
                    forms?.activeFilterSpecial
                      ? downlineMitra
                          ?.filter((val) =>
                            forms?.listMitra?.value == "all"
                              ? val
                              : val?.mitra_level == forms?.listMitra?.value
                          )
                          ?.map((item) => item?.mitra_id)
                      : forms?.listMitra?.map((item) => item?.value),
                    true
                  )
                }
                icon={{
                  left: (props) => <SaveSolidSvg {...props} />,
                }}
                className='w-full'
              />
            </div>
          </div>
        </ContainerModal>
      ) : typeModal == "setting-diskon" ? (
        <ContainerModal className={"flex max-w-[752px] flex-col gap-4"}>
          <div className='flex flex-col p-4 xs:p-8 gap-8'>
            <p className='subheading-medium text-greyscaleGON-400'>
              Pengaturan Diskon{" "}
              <span className='text-primaryGON-400 capitalize'>
                {dataModal?.user?.username}
              </span>
            </p>
            <div>
              {errors?.diskon_brand?.length > 0 && (
                <Label
                  colors='error'
                  title={errors?.diskon_brand}
                />
              )}
              <Divider />
            </div>
            <div className='flex w-full flex-col gap-8 overflow-hidden overflow-x-scroll'>
              <table className=' w-full'>
                <thead>
                  <tr>
                    <th className='w-[40%] pb-4'>
                      <p className='p1-medium whitespace-nowrap truncate text-greyscaleGON-400 capitalize text-start'>
                        Brand
                      </p>
                    </th>
                    <th className='w-[20%] pb-4'>
                      <p className='p1-medium whitespace-nowrap truncate text-greyscaleGON-400 capitalize text-start'>
                        Persentasi (%)
                      </p>
                    </th>
                    {/* <th className='w-[20%] pb-4'>
                      <p className='p1-medium whitespace-nowrap truncate text-greyscaleGON-400 capitalize text-start'>
                        Rupiah (Rp)
                      </p>
                    </th> */}
                    <th className='w-[20%] pb-4'>
                      <p className='p1-medium whitespace-nowrap truncate text-greyscaleGON-400 capitalize text-center'>
                        Aksi
                      </p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dataModal?.dataDiscount?.map((item, index) => (
                    <tr key={index}>
                      <td className='pr-4'>
                        <p className='p1-regular text-greyscaleGON-700 uppercase'>
                          {item?.name_brand}
                        </p>
                      </td>
                      <td className='pr-4'>
                        <div>
                          <Input
                            placeholder={"0%"}
                            disabled={
                              !disabled?.[item?.name_brand]
                              // showListTypeDiskon?.[item?.name_brand]?.value ==
                              //   "nominal"
                            }
                            value={forms?.discount_range?.[item?.name_brand]}
                            onSubmit={(e) => {
                              e.preventDefault();
                              handleChangeDiscount(item);
                            }}
                            onChange={(val) =>
                              setForms((old) => ({
                                ...old,
                                discount_range: {
                                  ...old?.discount_range,
                                  [item?.name_brand]: val,
                                },
                              }))
                            }
                          />
                        </div>
                      </td>
                      {/* <td>
                        <div>
                          <Input
                            placeholder={"Rp.0"}
                            enterKeyHint={"Rp"}
                            disabled={
                              !disabled?.[item?.name_brand]
                              // || showListTypeDiskon?.[item?.name_brand]?.value ==
                              //   "persentase"
                            }
                            value={forms?.discount_sale?.[item?.name_brand]}
                            onSubmit={(e) => {
                              e.preventDefault();
                              handleChangeDiscount(item);
                            }}
                            onChange={(val) =>
                              setForms((old) => ({
                                ...old,
                                discount_sale: {
                                  ...old?.discount_sale,
                                  [item?.name_brand]: val,
                                },
                              }))
                            }
                          />
                        </div>
                      </td> */}
                      <td
                        className={twMerge(
                          !disabled?.[item?.name_brand]
                            ? "justify-center"
                            : "justify-center",
                          "flex items-center py-2 pl-4"
                        )}>
                        {!disabled?.[item?.name_brand] ? (
                          <div
                            onClick={() =>
                              setDisabled((old) => ({
                                ...old,
                                [item?.name_brand]: true,
                              }))
                            }>
                            <PenEditSolidSvg className='text-secondaryGON-400 w-8 h-8' />
                          </div>
                        ) : (
                          <div className='relative justify-center flex flex-row items-center gap-4 '>
                            <div onClick={() => handleChangeDiscount(item)}>
                              <SaveSolidSvg className='text-primaryGON-400 w-8 h-8 cursor-pointer' />
                            </div>
                            <div
                              onClick={() =>
                                setDisabled((old) => ({
                                  ...old,
                                  [item?.name_brand]: false,
                                }))
                              }>
                              <RemoveSvg className='text-primaryGON-400 w-8 h-8 cursor-pointer' />
                            </div>
                            {/* <div
                              onClick={() =>
                                setShowListTypeDiskon((old) => ({
                                  ...old,
                                  [item?.name_brand]: {
                                    show: !showListTypeDiskon?.[
                                      item?.name_brand
                                    ]?.show,
                                  },
                                }))
                              }
                              className='flex flex-row items-center gap-1'>
                              <p className='p1-regular min-w-[20px]'>
                                {showListTypeDiskon?.[item?.name_brand]
                                  ?.value == "nominal"
                                  ? "Rp."
                                  : "%"}{" "}
                              </p>
                              <ChevronDownSvg className='text-greyscaleGON-700 w-4 h-4' />
                            </div>
                            {showListTypeDiskon?.[item?.name_brand]?.show && (
                              <div
                                className='absolute right-0 z-10 mt-2 w-fit origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none'
                                role='menu'
                                aria-orientation='vertical'
                                aria-labelledby='menu-button'
                                tabIndex='-1'>
                                <div
                                  className='py-1'
                                  role='none'>
                                  {[
                                    { label: "Rp", value: "nominal" },
                                    { label: "%", value: "persentase" },
                                  ]?.map((val, key) => (
                                    <span
                                      key={key}
                                      onClick={() => {
                                        setShowListTypeDiskon((old) => ({
                                          ...old,
                                          [item?.name_brand]: {
                                            show: !showListTypeDiskon?.[
                                              item?.name_brand
                                            ]?.show,
                                            value: val?.value,
                                          },
                                        }));
                                      }}
                                      className='text-gray-700 capitalize block px-4 py-2 text-sm cursor-pointer'
                                      role='menuitem'
                                      tabIndex='-1'
                                      id='menu-item-0'>
                                      {val?.label}
                                    </span>
                                  ))}
                                </div>
                              </div>
                            )} */}
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className='flex w-full xs:justify-end '>
                <Button
                  label='Tutup'
                  onClick={() => {
                    closeModal();
                    setDisabled({});
                  }}
                  className='xs:w-[12rem] w-full'
                />
              </div>
            </div>
          </div>
        </ContainerModal>
      ) : (
        <ContainerModal className={"flex flex-col gap-10"}>
          <div className='flex justify-between items-center'>
            <p className='sm:h4-semiBold h5-semiBold text-greyscaleGON-700'>
              Detail Jaringan
            </p>
            <div
              className='cursor-pointer justify-end flex'
              onClick={() => {
                closeModal();
              }}>
              <RemoveSvg className='h-6 w-6 xs:h-8 xs:w-8 text-greyscaleGON-700' />
            </div>
          </div>
          <div className='grid sm:grid-cols-2 gap-4'>
            {/* Informasi Pribadi */}
            <div className='w-full h-fit flex flex-col gap-4 sm:gap-8 p-4 sm:p-8 border border-greyscaleGON-200 rounded-2xl'>
              <div className='flex flex-row justify-between items-center'>
                <p className='subheading-semiBold text-greyscaleGON-400'>
                  Informasi Pribadi
                </p>
              </div>
              <div className='flex flex-col gap-2'>
                {[
                  {
                    title: "Nama Lengkap",
                    value: dataModal?.user?.username,
                  },
                  {
                    title: "Level Kemitraan",
                    value: checkLevel(dataModal?.user?.mitra_level),
                  },
                  {
                    title: "Tanggal Lahir",
                    value: dataModal?.user?.date_of_birth,
                  },
                  {
                    title: "Nomor HP",
                    value: dataModal?.user?.telephone,
                  },
                  {
                    title: "Jenis Kelamin",
                    value:
                      dataModal?.user?.gender == "L"
                        ? "Laki-Laki"
                        : "Perempuan",
                  },
                ]?.map((a, b) => (
                  <div
                    key={b}
                    className='flex flex-col sm:flex-row sm:items-center sm:gap-4 w-full'>
                    <p className='p1-regular text-greyscaleGON-400 sm:min-w-[10rem] line-clamp-1'>
                      {a.title}
                    </p>
                    <p className='p1-regular text-greyscaleGON-700 line-clamp-1'>
                      : {a.value ?? "-"}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Informasi Alamat */}
            <div className='w-full h-fit flex flex-col gap-4 sm:gap-8 p-4 sm:p-8 border border-greyscaleGON-200 rounded-2xl'>
              <div className='flex flex-row justify-between items-center'>
                <p className='subheading-semiBold text-greyscaleGON-400'>
                  Informasi Alamat
                </p>
              </div>
              <div className='flex flex-col gap-2'>
                {[
                  {
                    title: "Provinsi",
                    value: dataModal?.user?.address_information?.province_name,
                  },
                  {
                    title: "Kabupaten",
                    value: dataModal?.user?.address_information?.city_name,
                  },
                  {
                    title: "Kecamatan",
                    value: dataModal?.user?.address_information?.district_name,
                  },
                  {
                    title: "Kelurahan",
                    value:
                      dataModal?.user?.address_information?.subdistrict_name,
                  },
                  {
                    title: "Detail Alamat",
                    value: dataModal?.user?.address_information?.address,
                  },
                ]?.map((a, b) => (
                  <div
                    key={b}
                    className='flex flex-col sm:flex-row sm:items-center sm:gap-4 w-full'>
                    <p className='p1-regular text-greyscaleGON-400 sm:min-w-[10rem] line-clamp-1'>
                      {a.title}
                    </p>
                    <p className='p1-regular text-greyscaleGON-700 line-clamp-1'>
                      : {a.value ?? "-"}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Informasi Dropshipper */}
            <div className='w-full h-fit flex flex-col gap-4 sm:gap-8 p-4 sm:p-8 border border-greyscaleGON-200 rounded-2xl'>
              <div className='flex flex-row justify-between items-center'>
                <p className='subheading-semiBold text-greyscaleGON-400'>
                  Informasi Dropshipper
                </p>
              </div>
              <div className='flex flex-col gap-2'>
                {[
                  {
                    title: "Nama Dropshipper",
                    value: dataModal?.user?.name_store,
                  },
                  {
                    title: "Nomor HP",
                    value: dataModal?.user?.telephone_store,
                  },
                ]?.map((a, b) => (
                  <div
                    key={b}
                    className='flex flex-col sm:flex-row sm:items-center sm:gap-4 w-full'>
                    <p className='p1-regular text-greyscaleGON-400 sm:min-w-[10rem] line-clamp-1'>
                      {a.title}
                    </p>
                    <p className='p1-regular text-greyscaleGON-700 line-clamp-1'>
                      : {a.value ?? "-"}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Informasi Akun */}
            <div className='w-full h-fit flex flex-col gap-4 sm:gap-8 p-4 sm:p-8 border border-greyscaleGON-200 rounded-2xl'>
              <div className='flex flex-row justify-between items-center'>
                <p className='subheading-semiBold text-greyscaleGON-400'>
                  Informasi Akun
                </p>
              </div>
              <div className='flex flex-col gap-2'>
                {[
                  {
                    title: "Email",
                    value: dataModal?.user?.email,
                  },
                  {
                    title: "Kata Sandi",
                    value: !dataModal.user.password
                      ? ""
                      : decryptPassword(
                          dataModal.user.password,
                          "password_key"
                        ),
                  },
                ]?.map((a, b) => (
                  <div
                    key={b}
                    className='flex flex-col sm:flex-row sm:items-center sm:gap-4 w-full group'>
                    <p className='p1-regular text-greyscaleGON-400 sm:min-w-[10rem] line-clamp-1'>
                      {a.title}
                    </p>
                    {!a.value ? (
                      <p className='p1-regular text-greyscaleGON-700'>: -</p>
                    ) : a.title == "Kata Sandi" ? (
                      <>
                        <div className='flex group-hover:hidden'>
                          <p className='p1-regular text-greyscaleGON-700'>
                            : {a.value?.slice(0, 2)}*****
                          </p>
                        </div>
                        <div className='hidden group-hover:flex'>
                          <p className='p1-regular text-greyscaleGON-700'>
                            : {a.value}
                          </p>
                        </div>
                      </>
                    ) : (
                      <p className='p1-regular text-greyscaleGON-700 line-clamp-1'>
                        : {a.value ?? "-"}
                      </p>
                    )}
                  </div>
                ))}
                {!resetPassword.active ? (
                  <div className='flex sm:self-end flex-col sm:items-center gap-2'>
                    <Button
                      className='w-full sm:self-end'
                      label='Salin kata sandi'
                      size='small'
                      disable={!dataModal.user.password}
                      onClick={() => {
                        navigator.clipboard.writeText(
                          decryptPassword(
                            dataModal.user.password,
                            "password_key"
                          )
                        );
                        toast.success("Berhasil salin kata sandi!", {
                          position: "top-center",
                        });
                      }}
                    />
                    <Button
                      className='w-full sm:self-end'
                      label='Reset kata sandi'
                      colors='error'
                      disable={
                        !dataModal?.user?.mitra_id ||
                        session.user.data.mitra_level !== 1
                      }
                      size='small'
                      variants='outline'
                      onClick={() =>
                        setResetPassword({
                          active: !resetPassword.active,
                        })
                      }
                    />
                  </div>
                ) : (
                  <>
                    <Divider />
                    <div className='flex flex-col gap-4'>
                      <Input
                        onSubmit={handleResetPassword}
                        label={"Kata Sandi"}
                        placeholder='Masukkan kata sandi'
                        type={!resetPassword.hidePw ? "password" : "text"}
                        icon={{
                          right: (props) =>
                            resetPassword.hidePw ? (
                              <EyeOffSvg {...props} />
                            ) : (
                              <EyeOnSvg {...props} />
                            ),
                          onClickRight: () =>
                            setResetPassword((old) => ({
                              ...old,
                              hidePw: !resetPassword.hidePw,
                            })),
                        }}
                        onChange={(value) =>
                          setResetPassword((old) => ({
                            ...old,
                            new_password: value,
                          }))
                        }
                        value={resetPassword.new_password}
                        footer={{
                          title: "Auto Generate",
                          onClick: () =>
                            setResetPassword((old) => ({
                              ...old,
                              new_password: generateRandomString(8),
                              hidePw: true,
                            })),
                        }}
                      />
                      <div className='flex flex-col sm:flex-row sm:items-center gap-4'>
                        <Button
                          className='w-full'
                          label='Batalkan'
                          disable={loading.resetPassword}
                          size='small'
                          variants='outline'
                          onClick={() =>
                            setResetPassword({
                              active: !resetPassword.active,
                            })
                          }
                        />
                        <Button
                          className='w-full'
                          loading={loading.resetPassword}
                          disable={
                            loading.resetPassword || !resetPassword.new_password
                          }
                          label='Simpan'
                          size='small'
                          onClick={handleResetPassword}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </ContainerModal>
      )}
    </React.Fragment>
  );
}
